import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

const ProgressBarWrapper = styled.div`
  position: absolute;
  flex-grow: 0;
  height: 17px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 1.75px;
  text-transform: uppercase;
  color: ${({ theme, shouldChangeTextColor }) =>
    shouldChangeTextColor ? theme.colors.white : theme.colors.promo};
  z-index: 1;
  transition: color 400ms ease-in 100ms;
`;

const ProgressBar = styled.div`
  background-color: ${({ theme }) => theme.colors.promo};
  flex-grow: 0;
  height: ${({ theme }) => theme.spacing.tiny}px;
  width: ${props => props.percentComplete}%;
  transition: width 400ms ease-in;
`;

const ProgressBarTrack = styled.div`
  flex-grow: 0;
  height: ${({ theme }) => theme.spacing.tiny}px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
`;

const ProgressLabel = styled.div`
  margin-top: 11px;

  color: ${({ theme }) => theme.colors.white};
  ${props => props.theme.subHeader.variants.subHeading4Uppercase.textStyles}
  font-size: 14px;
`;

const QuizProgressBar = ({
  currentStep: adjustedCurrentStep,
  totalSteps: adjustedTotalSteps,
}) => {
  return (
    <ProgressBarWrapper>
      <ProgressBarTrack>
        <ProgressBar
          percentComplete={(adjustedCurrentStep / adjustedTotalSteps) * 100}
        />
      </ProgressBarTrack>
      <ProgressLabel>
        <FormattedMessage
          id="global_quiz.progress_text"
          defaultMessage="STEP {adjustedCurrentStep} OF {adjustedTotalSteps}"
          values={{
            adjustedCurrentStep,
            adjustedTotalSteps,
          }}
        />
      </ProgressLabel>
    </ProgressBarWrapper>
  );
};

QuizProgressBar.propTypes = {
  currentStep: PropTypes.number,
  totalSteps: PropTypes.number,
};

export default QuizProgressBar;
